import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getAwsAuthUtil } from '../../../../main/utils/aws/aws-auth.util.ts';

import { selectUserAuthStatus } from '../../../selectors/user-auth-status.selector.ts';

import { setIsParentInfoVisible } from '../accounts.slice.ts';
import { ACCOUNTS_SLICE_NAME } from '../accounts.slice.types.ts';

export const updateParentInfoVisibilityThunk = createAsyncThunk<void, void, ThunkApiConfigType>(
  `${ACCOUNTS_SLICE_NAME}/updateParentInfoVisibility`,
  async (_, thunkAPI) => {
    const isUserAuthenticated = selectUserAuthStatus(thunkAPI.getState());
    if (!isUserAuthenticated) {
      return;
    }

    const isParentOrGuardian = await getAwsAuthUtil().isParentOrGuardian();
    thunkAPI.dispatch(setIsParentInfoVisible(isParentOrGuardian));
  }
);
